var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.deviceConfiguration
      ? _c("h3", { staticClass: "text-center mb-6" }, [
          _vm._v(" " + _vm._s(_vm.$t("roomWizard.addLicenseDescription")) + " ")
        ])
      : _vm._e(),
    _vm.licenseMode == undefined
      ? _c(
          "div",
          {
            staticClass:
              "\n      d-flex\n      flex-column flex-md-row\n      justify-center justify-md-space-around\n      align-center\n      my-8\n    "
          },
          [
            _c(
              "v-btn",
              {
                staticClass: "mb-4 mb-md-0 license-btn",
                attrs: { color: "primary", loading: _vm.loading },
                on: {
                  click: function($event) {
                    _vm.licenseMode = "existing"
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("roomWizard.existingLicense")) + " ")]
            ),
            _c(
              "v-btn",
              {
                staticClass: "mb-4 mb-md-0 license-btn",
                attrs: { color: "primary", loading: _vm.loading },
                on: {
                  click: function($event) {
                    _vm.licenseMode = "new"
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("roomWizard.newLicense")) + " ")]
            ),
            _vm.canActivateTrial
              ? _c(
                  "v-btn",
                  {
                    staticClass: "mb-4 mb-md-0 license-btn",
                    attrs: { color: "primary", loading: _vm.loading },
                    on: { click: _vm.checkAvailableTrials }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("roomWizard.startTrial")) + " ")]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm.licenseMode == "trial"
      ? _c("div", [
          _c(
            "div",
            {
              staticClass:
                "\n        d-flex\n        flex-column flex-md-row\n        justify-center justify-md-space-around\n        align-center\n        mt-10\n        mb-8\n      "
            },
            [
              _vm.avaliableTrials.length == 0
                ? _c("div", [
                    _vm._v(" " + _vm._s(_vm.$t("roomWizard.noTrials")) + " ")
                  ])
                : _vm._e(),
              _vm._l(_vm.avaliableTrials, function(trial, index) {
                return _c(
                  "v-btn",
                  {
                    key: index,
                    staticClass: "mb-4 mb-md-0",
                    attrs: { color: "primary", loading: _vm.loading },
                    on: {
                      click: function($event) {
                        return _vm.startTrial(trial)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(trial.name) + " ")]
                )
              })
            ],
            2
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.licenseMode = undefined
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("roomWizard.prev")))]
          )
        ])
      : _vm._e(),
    _vm.licenseMode == "new"
      ? _c(
          "div",
          [
            _c("new-license", {
              on: {
                onDismiss: function($event) {
                  _vm.licenseMode = undefined
                },
                onFinish: _vm.associateLicense
              }
            }),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.licenseMode = undefined
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("roomWizard.prev")))]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.licenseMode == "existing"
      ? _c(
          "div",
          [
            _c("chose-license", {
              attrs: { "device-configuration": _vm.deviceConfiguration },
              on: {
                onDismiss: function($event) {
                  _vm.licenseMode = undefined
                },
                onFinish: _vm.associateLicense
              },
              model: {
                value: _vm.license,
                callback: function($$v) {
                  _vm.license = $$v
                },
                expression: "license"
              }
            }),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.licenseMode = undefined
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("roomWizard.prev")))]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }